import { render, staticRenderFns } from "./HighGraduateLiquidIndicatorSvg.vue?vue&type=template&id=3d2812f7&"
import script from "./HighGraduateLiquidIndicatorSvg.vue?vue&type=script&lang=js&"
export * from "./HighGraduateLiquidIndicatorSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports